<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Carnet', route: '/backoffice/carnet' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Elenco carnet</h2>
    </div>

    <p-table #dt
        [loading]="loading"
        [value]="carnets"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['titoli']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} carnet"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50]"
        (onRowReorder)="onReorder($event)">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full items-stretch">
                <input type="text" pInputText class="flex-1" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca carnet…" />
                <div class="table-toolbar-btns">
                    <button class="acc-btn" type="button" (click)="onOpenInfo()">Gestisci info carnet</button>
                    <a class="acc-btn acc-btn-primary" routerLink="/backoffice/carnet/add">
                        <i class="bi bi-plus"></i>
                        Aggiungi carnet
                    </a>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="w-1/12"></th>
                <th pSortableColumn="titoli" class="w-8/12">Titolo/i <span class="inline-flex"><p-sortIcon field="titoli" /></span></th>
                <th class="w-3/12 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-carnet let-index="rowIndex">
            <tr [pReorderableRow]="index">
                <td class="text-center">
                    <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
                </td>
                <td>
                    <span class="p-column-title">Titolo/i</span>
                    <span class="cell-nome">{{carnet.titoli}}</span>
                </td>
                <td class="text-center">
                    <span class="p-column-title">Azioni</span>
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/carnet/' + carnet.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteCarnet>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteCarnet()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteCarnet()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteCarnet($event, carnet)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun carnet trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>

<p-dialog [visible]="add_info" [style]="{width: '50%'}" header="Gestisci info carnet" [focusOnShow]="false" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="add_info = false">
    <ng-template pTemplate="content">
        <form [formGroup]="formInfo" class="accrediti-form flex flex-col gap-6" (ngSubmit)="!carnet_info?.id ? onAddInfo() : onUpdateInfo()">
            <div class="fld">
                <p-checkbox label="Pagina carnet attiva" formControlName="attivo" value="attivo" pTooltip="Se deselezionato, il link viene nascosto da navbar e footer e la pagina non è raggiungibile" tooltipPosition="top" />
            </div>
            <div class="fld">
                <label>* Titolo</label>
                <input type="text" pInputText class="w-full" formControlName="titolo" />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formInfo.get('titolo')?.hasError('required') && (formInfo.get('titolo')?.dirty || formInfo.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
            </div>
            <div class="fld">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
            </div>
            <div class="fld">
                <label>Link</label>
                <input type="text" pInputText class="w-full" formControlName="link" />
            </div>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="add_info = false">Annulla</button>
                <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formInfo.valid">{{carnet_info?.id ? 'Modifica' : 'Aggiungi'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
